export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string | string[]) {
  const current = getCurrentUrl(pathname)

  if (Array.isArray(url)) {
    return url.some(path => current.startsWith(path))
  }

  return current.startsWith(url)
}
